import React, { useState } from "react";
import "../Contact.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { Link } from "react-router-dom";

import {
    FiChevronRight,
    FiMapPin,
    FiMail,
    FiPhone,
    FiClock,
    FiSend,
    FiShield,
    FiCheckCircle,
    FiCpu,
    FiTrendingUp
} from "react-icons/fi";



const Contact = () => {

    const [formData, setFormData] = useState({
        name: "",
        company: "",
        email: "",
        phone: "",
        service: "",
        message: "",
    });

    const [formMessage, setFormMessage] = useState("");
    const [messageType, setMessageType] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Remove old message when user edits the form
        if (formMessage) {
            setFormMessage("");
            setMessageType("");
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const {
            name,
            company,
            email,
            phone,
            service,
            message,
        } = formData;

        // Required field validation
        if (!name.trim()) {
            setMessageType("error");
            setFormMessage("Please enter your name.");
            return;
        }

        if (!company.trim()) {
            setMessageType("error");
            setFormMessage("Please enter your company name.");
            return;
        }

        if (!email.trim()) {
            setMessageType("error");
            setFormMessage("Please enter your email address.");
            return;
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email.trim())) {
            setMessageType("error");
            setFormMessage("Please enter a valid email address.");
            return;
        }

        if (!phone.trim()) {
            setMessageType("error");
            setFormMessage("Please enter your phone number.");
            return;
        }

        // Phone validation
        const phoneRegex = /^[0-9+\-\s()]{7,20}$/;

        if (!phoneRegex.test(phone.trim())) {
            setMessageType("error");
            setFormMessage("Please enter a valid phone number.");
            return;
        }

        if (!service) {
            setMessageType("error");
            setFormMessage("Please select a service.");
            return;
        }

        if (!message.trim()) {
            setMessageType("error");
            setFormMessage("Please enter your message.");
            return;
        }

        // Successful submission
        setMessageType("success");
        setFormMessage(
            "Thank you for contacting us! Our team will connect with you shortly."
        );

        // Clear form
        setFormData({
            name: "",
            company: "",
            email: "",
            phone: "",
            service: "",
            message: "",
        });
    };


    return (

        <>

            <Header />


            <div className="contact-page">



                {/*=====================================================
                    HERO SECTION
======================================================*/}


                <section className="contact-hero">


                    <div className="container">


                        <div className="contact-hero-content">


                            <span className="contact-tag">
                                GET IN TOUCH
                            </span>


                            <h1>

                                Let's Build Secure

                                <span>
                                    FinTech Solutions Together
                                </span>

                            </h1>


                            <p>

                                Connect with Saivari Fintech experts to
                                discuss fintech consulting, AML services,
                                KYC verification, compliance solutions,
                                payment technology, and digital
                                transformation initiatives.

                            </p>



                            <div className="contact-buttons">


                                {/* <Link
                                    to="/services"
                                    className="contact-primary-btn"
                                >

                                    Explore Services

                                </Link>


                                <Link
                                    to="/contact"
                                    className="contact-secondary-btn"
                                >

                                    Contact Experts

                                </Link> */}


                            </div>



                        </div>


                    </div>


                </section>





                {/*=====================================================
                    BREADCRUMB
======================================================*/}


                <section className="contact-breadcrumb">


                    <div className="container">


                        <Link to="/">
                            Home
                        </Link>


                        <FiChevronRight />


                        <span>
                            Contact
                        </span>


                    </div>


                </section>







                {/*=====================================================
                CONTACT INFORMATION
======================================================*/}



                <section className="contact-info-section">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                CONTACT INFORMATION
                            </span>


                            <h2>

                                Reach Our

                                <span>
                                    FinTech Experts
                                </span>

                            </h2>


                            <p>

                                Whether you need technology consulting,
                                compliance support, or digital financial
                                solutions, our team is ready to assist you.

                            </p>


                        </div>




                        <div className="contact-info-grid">



                            <div className="contact-info-card">


                                <div className="contact-icon">

                                    <FiMapPin />

                                </div>


                                <h3>
                                    Office Address
                                </h3>


                                <p>

                                    Plot No 532 To 534, Ayyappa Society, Madhapur, Cyberabad, Hyderabad, Shaikpet, Telangana, India, 500081

                                </p>


                            </div>





                            <div className="contact-info-card">


                                <div className="contact-icon">

                                    <FiMail />

                                </div>


                                <h3>
                                    Email Us
                                </h3>


                                <p>

                                    support@techsaivari.in

                                </p>


                            </div>





                            <div className="contact-info-card">


                                <div className="contact-icon">

                                    <FiPhone />

                                </div>


                                <h3>
                                    Call Us
                                </h3>


                                <p>

                                    +919799536210

                                </p>


                            </div>





                            <div className="contact-info-card">


                                <div className="contact-icon">

                                    <FiClock />

                                </div>


                                <h3>
                                    Business Hours
                                </h3>


                                <p>

                                    Monday - Saturday

                                    <br />

                                    9:00 AM - 6:30 PM

                                </p>


                            </div>



                        </div>


                    </div>


                </section>









                <section className="contact-form-section">


                    <div className="container">



                        <div className="contact-form-wrapper">



                            <div className="contact-form-content">


                                <span className="section-tag">

                                    SEND MESSAGE

                                </span>



                                <h2>

                                    Discuss Your

                                    <span>
                                        FinTech Requirements
                                    </span>

                                </h2>



                                <p>

                                    Tell us about your business requirements
                                    and our experts will connect with you to
                                    design secure and scalable solutions.

                                </p>



                                <div className="form-points">


                                    <div>

                                        <FiCheckCircle />

                                        AML & KYC Consultation

                                    </div>


                                    <div>

                                        <FiCheckCircle />

                                        Compliance Advisory

                                    </div>


                                    <div>

                                        <FiCheckCircle />

                                        Technology Solutions

                                    </div>


                                    <div>

                                        <FiCheckCircle />

                                        Digital Transformation

                                    </div>


                                </div>


                            </div>







                            <form className="contact-form" onSubmit={handleSubmit}>

                                <div className="form-row">

                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Your Name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />

                                    <input
                                        type="text"
                                        name="company"
                                        placeholder="Company Name"
                                        value={formData.company}
                                        onChange={handleChange}
                                    />

                                </div>


                                <div className="form-row">

                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email Address"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />

                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Phone Number"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />

                                </div>


                                <select
                                    name="service"
                                    value={formData.service}
                                    onChange={handleChange}
                                >
                                    <option value="">
                                        Select Service
                                    </option>

                                    <option value="FinTech Consulting">
                                        FinTech Consulting
                                    </option>

                                    <option value="AML Managed Services">
                                        AML Managed Services
                                    </option>

                                    <option value="KYC Verification">
                                        KYC Verification
                                    </option>

                                    <option value="Compliance Support">
                                        Compliance Support
                                    </option>

                                    <option value="Payment Solutions">
                                        Payment Solutions
                                    </option>
                                </select>


                                <textarea
                                    name="message"
                                    rows="5"
                                    placeholder="Your Message"
                                    value={formData.message}
                                    onChange={handleChange}
                                />


                                <button type="submit">
                                    <FiSend />
                                    Send Message
                                </button>


                                {/* SUBMISSION MESSAGE */}

                                {formMessage && (
                                    <div
                                        className={`contact-form-message ${messageType === "success"
                                            ? "success-message"
                                            : "error-message"
                                            }`}
                                    >
                                        {formMessage}
                                    </div>
                                )}

                            </form>



                        </div>


                    </div>


                </section>










                <section className="contact-benefits">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                WHY WORK WITH US
                            </span>


                            <h2>

                                Your Trusted

                                <span>
                                    FinTech Technology Partner
                                </span>

                            </h2>


                        </div>





                        <div className="contact-benefit-grid">



                            <div className="contact-benefit-card">


                                <FiShield />


                                <h3>
                                    Security First
                                </h3>


                                <p>

                                    Enterprise-grade security practices
                                    designed for financial ecosystems.

                                </p>


                            </div>





                            <div className="contact-benefit-card">


                                <FiCpu />


                                <h3>
                                    Technology Expertise
                                </h3>


                                <p>

                                    Modern cloud, API, automation,
                                    and fintech architecture solutions.

                                </p>


                            </div>





                            <div className="contact-benefit-card">


                                <FiTrendingUp />


                                <h3>
                                    Business Growth
                                </h3>


                                <p>

                                    Solutions designed to improve
                                    efficiency and scalability.

                                </p>


                            </div>



                        </div>



                    </div>


                </section>











                {/* 
                <section className="contact-cta">


                    <div className="container">


                        <div className="contact-cta-box">


                            <h2>

                                Ready To Transform Your

                                <span>
                                    Financial Technology?
                                </span>

                            </h2>


                            <p>

                                Partner with Saivari Fintech for secure,
                                compliant, and innovative fintech solutions.

                            </p>



                            <Link
                                to="/contact"
                                className="contact-primary-btn"
                            >

                                Get Consultation

                            </Link>



                        </div>


                    </div>


                </section> */}



            </div>


            <Footer />


        </>

    )


}


export default Contact;